import React from 'react'
import Box from '@material-ui/core/Box'
import EmptyPageState, { TonalButton } from 'components/empty-page-state'
import MessageOutlinedIcon from 'components/material-symbol/icons/Message'
import NewConversationDialog from './new-conversation-dialog'

const EmptyChannel = () => {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <EmptyPageState
        IconComp={() => <MessageOutlinedIcon />}
        title="No conversations yet"
        caption="Messages will appear here once you start a conversation"
        action={
          <NewConversationDialog
            trigger={<TonalButton>Start a New Message</TonalButton>}
          />
        }
      />
    </Box>
  )
}

export default EmptyChannel
